import PropTypes from 'prop-types';
import React from 'react';

const Home = ({ className }) => (
  <svg width="13px" height="15px" viewBox="0 0 13 15" version="1.1" className={className}>
    <g strokeWidth="1" fillRule="evenodd">
      <g id="Group" transform="translate(-7.000000, -5.000000)" strokeWidth="0.5">
        <path
          d={`M6.60000006,8 C6.26863507,8 6,8.27418773 6,8.61243972 C6,8.95069018 6.26863507,
            9.22487945 6.60000006,9.22487945 L17.4,9.22487945 C17.7313652,9.22487945 18,
            8.95069018 18,8.61243972 C18,8.27418773 17.7313652,8 17.4,8 L6.60000006,
            8 Z M6.60000006,11.3875649 C6.26863507,11.3875649 6,11.6617373 6,12.0000031 C6,
            12.3382535 6.26863507,12.6124428 6.60000006,12.6124428 L17.4,12.6124428 C17.7313652,
            12.6124428 18,12.3382535 18,12.0000031 C18,11.6617373 17.7313652,11.3875649 17.4,
            11.3875649 L6.60000006,11.3875649 Z M6.60000006,14.7751206 C6.26863507,14.7751206 6,
            15.0493098 6,15.3875603 C6,15.7258107 6.26863507,16 6.60000006,16 L17.4,16 C17.7313652,
            16 18,15.7258107 18,15.3875603 C18,15.0493098 17.7313652,14.7751206 17.4,
            14.7751206 L6.60000006,14.7751206 Z`}
          id="Combined-Shape"
        />
      </g>
    </g>
  </svg>
);

Home.propTypes = {
  className: PropTypes.string,
};

Home.defaultProps = {
  className: '',
};

export default Home;
